import React from 'react';
import Chart from '../Chart';
import PopUpDivChild from 'lib/reusable-components/PopUpDivChild/PopUpDivChild';
import './fullScreenPopupChart.scss';
const FullScreenPopupChart = (props: any) => {
  const { isFullScreenPopupChart, setIsFullScreenPopupChart } = props;
  return (
    <div className='fullScreenPopupChartContainer'>
      <PopUpDivChild
        initialValue={isFullScreenPopupChart}
        setPopUp={setIsFullScreenPopupChart}
        header={false}
        className='fullScreenPopupChart'
      >
        <Chart
          {...props}
          cardWidth={'FULL'}
          outerClassName={''}
          isCloseButtonShow={true}
          handleCloseButton={setIsFullScreenPopupChart}
        />
      </PopUpDivChild>
    </div>
  );
};

export default FullScreenPopupChart;
